import React from 'react';

import { FolderStarNew } from '@videoblocks/react-icons';

import { LoggerFn } from '../../../app/Shared/types';

type Props = { logger: LoggerFn };

const MyFoldersButton = ({ logger }: Props) => {
  return (
    <a
      href="/member/folders"
      onClick={() => logger('nav.clickFavorites')}
      aria-label="folder"
      className="focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:ring-offset-white"
    >
      <FolderStarNew className="fill-current h-6 w-6 cursor-pointer relative text-white" />
    </a>
  );
};

export default MyFoldersButton;
